import { render, staticRenderFns } from "./ProdutoDescricao.vue?vue&type=template&id=6e299c9d&scoped=true"
import script from "./ProdutoDescricao.vue?vue&type=script&lang=js"
export * from "./ProdutoDescricao.vue?vue&type=script&lang=js"
import style0 from "./ProdutoDescricao.vue?vue&type=style&index=0&id=6e299c9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../corporativo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e299c9d",
  null
  
)

export default component.exports